import React, { useEffect, useState } from 'react';
import { Form as AntdForm } from 'antd';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  signUpByPhone as signUpByPhoneAction,
  SignUpByPhoneAction,
} from '@triare/auth-redux/dist/saga/auth/signUp';
import { Action } from '@triare/auth-redux';
import { Error, AnyObject } from '@triare/auth-redux/dist/saga/common';
import {
  createRulesForAntd,
  validationSignUpPhoneOnly,
} from '../../../../../utils/validations';
import Form from '../Form';
import PhoneNumberInput from '../../../../Common/PhoneNumberInput';
import { RootState } from '../../../../../store';
import { moduleName } from '../../../../../store/auth';
import { ContentProps } from '../index';
import Footer from '../Footer';
import Separator from '../../../../Common/Form/Separator';
import ButtonGoogle from '../Form/ButtonGoogle';
import ButtonApple from '../Form/ButtonApple';
import ButtonFacebook from '../Form/ButtonFacebook';

const validationRules = createRulesForAntd(validationSignUpPhoneOnly);

interface PhoneProps extends ContentProps {
  response: AnyObject | null;
  error: Error | null;
  signUp: (payload: SignUpByPhoneAction) => Action;
}

function Phone({
  response, error, signUp, onSubmit,
}: PhoneProps): React.ReactNode {
  const [signUpData, setSignUpData] = useState<SignUpByPhoneAction | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!error && response && onSubmit) {
      onSubmit(signUpData);
    }
  }, [response, error, onSubmit]);

  return (
    <>
      <Form<SignUpByPhoneAction>
        validationRules={validationRules}
        signUp={(props) => {
          const data: SignUpByPhoneAction = {
            ...props,
            // _query: {
            //   lang: 'en',
            // },
          };

          setSignUpData(data);
          signUp(data);
        }}
        name="signUpPhone"
      >
        <AntdForm.Item
          name="phone"
          label={`${t('phone')} *`}
          rules={[validationRules]}
        >
          <PhoneNumberInput
            placeholder="321567926"
            // placeholder={t('phone') || 'Phone'}
            size="large"
          />
        </AntdForm.Item>
      </Form>

      <Separator />

      <AntdForm.Item>
        <ButtonGoogle />
      </AntdForm.Item>

      <AntdForm.Item>
        <ButtonApple />
      </AntdForm.Item>

      <AntdForm.Item>
        <ButtonFacebook />
      </AntdForm.Item>

      <Footer />
    </>
  );
}

export default connect((state: RootState) => ({
  response: state[moduleName].signUp.response,
  error: state[moduleName].signUp.error,
}), {
  signUp: signUpByPhoneAction,
})(Phone);
